import { IEvent } from "@lib/store/src/calendar";
import styles from "../styles.css";
import { getOptionTemplateByType } from "../modal.templates";
import { createTimePickerSelect } from "../modal.helpers";
import i18next from "i18next";

export const getEditEventWeekTemplate = () => `
    <style>
        ${styles}
    </style>
    <div class="modal-week-container">
        <div class="input-container" slot="children">
 
            <div class="form-row">
                <div class="form-block">
                    <p class="form-label">${i18next.t($ => $.scheduleBacnet.dayOfWeek)}</p> 
                    <fw-radio-group id="week-day-edit" name="week-day-edit" orientation="row" >
                        <fw-radio value="0" disabled>${i18next.t($ => $.scheduleBacnet.mo)}</fw-radio>
                        <fw-radio value="1" disabled>${i18next.t($ => $.scheduleBacnet.tu)}</fw-radio>
                        <fw-radio value="2" disabled>${i18next.t($ => $.scheduleBacnet.we)}</fw-radio>
                        <fw-radio value="3" disabled>${i18next.t($ => $.scheduleBacnet.th)}</fw-radio>
                        <fw-radio value="4" disabled>${i18next.t($ => $.scheduleBacnet.fr)}</fw-radio>
                        <fw-radio value="5" disabled>${i18next.t($ => $.scheduleBacnet.sa)}</fw-radio>
                        <fw-radio value="6" disabled>${i18next.t($ => $.scheduleBacnet.su)}</fw-radio>
                    </fw-radio-group>  
                </div>          
            </div>
 
            <div class="grid-container grid-container_single">
                <div class="grid-header">
                    <div>${i18next.t($ => $.scheduleBacnet.time)}</div>
                    <div>${i18next.t($ => $.scheduleBacnet.dataType)}</div>
                    <div>${i18next.t($ => $.scheduleBacnet.value)}</div>
                    <div></div> <!-- Пустой элемент для крестика удаления -->
                </div>
                <div class="grid-body" id="events">
                    
                </div>
            </div>  
        </div>
        
        <div class="modal-buttons-wrap">
            <fw-tooltip id="tooltip" placement="bottom" trigger="hover" content="">
                <fw-button id="submit" color="primary">${i18next.t($ => $.apply)}</fw-button>
            </fw-tooltip>
            <fw-button id="reset" color="secondary">${i18next.t($ => $.cancel)}</fw-button>
        </div>
    </div>
`;

export const getEditEventTemplate = (event: IEvent) => `
    ${createTimePickerSelect(
      `${event?.time?.hours}:${event?.time?.minutes}:${event?.time?.seconds || "00"}`
    )}
    <select
        id="select-type"
        placeholder="${i18next.t($ => $.scheduleBacnet.chooseDataType)}"
        value="${event?.dataType}"
    >
    </select>
    <div id="block-value">
        ${getOptionTemplateByType(event?.dataType, event?.value)}
    </div>
    <div class="delete-btn">✕</div>
`;
